import Vue from "vue";

const END_POINT = "new-turno-examen";

export default {
  vigentes() {
    return Vue.prototype.$axios.get(END_POINT + "/custom/vigentes");
  },
  byCarrera(carreraId) {
    return Vue.prototype.$axios.get(END_POINT + "/custom/bycarrera", {
      params: { carrera_id: carreraId },
    });
  },
};
